import { Component, NgModule, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-footer',
    template: ` <footer><ng-content></ng-content></footer> `,
    styleUrls: ['./app-footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppFooterComponent {}

@NgModule({
  declarations: [AppFooterComponent],
  exports: [AppFooterComponent],
})
export class AppFooterModule {}
